const ProgressBar = ({ value }) => {
  return (
    <div className="w-full rounded-full bg-gray-200 dark:bg-gray-700 overflow-auto">
      <div
        className="h-1 bg-teal-600 dark:bg-teal-800 transition-all duration-500 rounded-full"
        style={{ width: `${value}%` }}
      ></div>
    </div>
  );
};

export default ProgressBar;
